import { useEffect }    from 'react';
import { connect }      from 'react-redux';
// Redux
import {getContacts}    from '../../redux/actions/Contacts';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/contacts';

const Index = ({stateView, token, getContacts}) => {
    const GetData = async() =>{
        const res = await getData(token)
        getContacts(res.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Contácto' view={false} />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getContacts})(Index);
